import * as Leaflet from 'leaflet';

export default function pixelToLatLng(px: number, py: number, bounds: Leaflet.LatLngBounds, mapWidth: number, mapHeight: number) {
  // mapWidth/mapHeight: image pixel size
  const xFrac = mapWidth === 0 ? 0 : px / mapWidth;
  const yFrac = mapHeight === 0 ? 0 : py / mapHeight;

  const north = bounds.getNorth();
  const south = bounds.getSouth();
  const west  = bounds.getWest();
  const east  = bounds.getEast();

  const lat = north - yFrac * (north - south);
  const lng = west  + xFrac * (east  - west);

  return Leaflet.latLng(lat, lng);
}
